import { useSearchParams } from 'next/navigation';
import { getSkuList } from '@storefront/app/pdp-config/printer/utils/utils';
import {
  GetSkuProductsDocument,
  GetSkuProductsQuery,
} from '@storefront/data-commerce';
import { BundleProductWithLowestPrice } from '@storefront/app/pdp-config/printer/product-configuration/product-configuration.utils';
import { useSuspenseQuery } from '@apollo/client';

import useProductsInfo from '@storefront/hooks/useProductsInfo';

export default function useGetProductsData() {
  const skuList = getSkuList(useSearchParams()?.get('skus'));
  const {
    data: { products },
  } = useSuspenseQuery<GetSkuProductsQuery>(GetSkuProductsDocument, {
    variables: { skuList },
  });
  const multipleProduct = products?.items as BundleProductWithLowestPrice[];

  const { productsOptions, productsInfo } = useProductsInfo(multipleProduct);
  return { productsOptions, productsInfo, multipleProduct };
}
